import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { SwapContractWizardStoreEffects } from './effects';
import * as fromSwapContractWizardStore from './reducer';

export function provideAllocationSwapContractWizardStoreV26(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(fromSwapContractWizardStore.swapContractWizardStoreFeatureKey, fromSwapContractWizardStore.reducer),
    provideEffects(SwapContractWizardStoreEffects),
  ]);
}
